<template>
  <div class="h-full w-full">
    <div :id="mapTagId" class="w-full h-full"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MapComponent',
  components: {},
  props: {},
  data() {
    return {
      map: null,
      geolocate: null,
      mapTagId: this.$Commons.generateUUID(),
      apiKey:
        'pk.eyJ1IjoiZXVsZXI4MTAwIiwiYSI6ImNtNWk2NTdmczBydXAyaXNkYzdsbDFtMTQifQ.0I5546X6Ei4TrZPjwZXqBA',
      markers: {},
    }
  },
  mounted() {},
  unmounted() {},
  methods: {
    centerToUserPosition() {
      if (!this.map || !this.geolocate) {
        return { success: false }
      }
      this.geolocate?.trigger()
      return { success: true }
    },
    initMap() {
      if (this.map) {
        console.log('map already initiated')
        this.centerToUserPosition()
        return
      }
      mapboxgl.accessToken = this.apiKey
      this.map = new mapboxgl.Map({
        container: this.mapTagId, // container ID
        style: 'mapbox://styles/mapbox/streets-v12', // style URL
        center: [2.4161, 6.3598], // starting position [lng, lat]
        zoom: 11, // starting zoom
        minZoom: 11, // starting zoom
      })
      this.map.addControl(new mapboxgl.NavigationControl())
      this.geolocate = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: false, // camera wont folow user real movement
        showUserHeading: true,
      })
      this.map.addControl(this.geolocate)
      this.map.on('load', () => {
        this.geolocate.trigger()
      })
      this.geolocate.on('geolocate', position => {
        console.log(position?.coords?.longitude)
        this.$emit('userCoordinateGot', {
          longitude: position?.coords?.longitude,
          latitude: position?.coords?.latitude,
        })
      })
    },
    createMarker(lng, lat, id = this.$Commons.generateUUID()) {
      if (!this.map) {
        return { success: false }
      }
      if (this.markers[id]) {
        this.markers[id].remove()
        this.markers[id] = null
      }
      this.markers[id] = new mapboxgl.Marker({
        color: '#FF7200',
        draggable: true,
      })
        .setLngLat([lng, lat])
        .addTo(this.map)

      this.map.jumpTo({
        center: [lng, lat],
        zoom: 14,
        pitch: 0,
      })
      return { success: true }
    },
    getMarkerCoordinates(id) {
      if (!id) return null
      if (!this.markers[id]) return null
      const lngLat = this.markers[id].getLngLat()
      return { longitude: lngLat.lng, latitude: lngLat.lat }
    },
  },
  watch: {},
})
</script>

<style>
.mapboxgl-ctrl-geolocate {
  display: none !important;
}
</style>
